import {memoize} from '@packages/utilities/memo';
import type {QueryVariables} from '../types';

const queryVariables = memoize(
  (
    itemId?: string | null,
    itemSlug?: string | null,
    searchQuery?: string | null,
    publishTarget?: string | null
  ): QueryVariables => {
    const variables = {
      query: searchQuery || '',
      publishTarget: publishTarget || '',
    } as const;

    if (itemId) {
      return {
        ...variables,
        itemId,
      };
    }

    if (itemSlug) {
      return {
        ...variables,
        itemSlug,
      };
    }

    return variables;
  }
);

export const createQueryVariables = ({
  itemId,
  itemSlug,
  searchQuery,
  publishTarget,
}: {
  itemId: string | null | undefined;
  itemSlug: string | null | undefined;
  searchQuery: string | null | undefined;
  publishTarget: string | null | undefined;
}): QueryVariables => {
  return queryVariables(itemId, itemSlug, searchQuery, publishTarget);
};
